
import React from 'react';
import { Lock } from 'lucide-react';
import { User } from '@supabase/supabase-js';

interface AuthNoticeBarProps {
  user: User | null;
  canVote: boolean;
}

const AuthNoticeBar: React.FC<AuthNoticeBarProps> = ({ user, canVote }) => {
  // If user is logged in but can't vote
  if (user && canVote === false) {
    return (
      <div className="px-6 py-2 mb-2">
        <div className="bg-amber-50 p-3 rounded-md flex items-center">
          <Lock size={16} className="text-amber-500 mr-2" />
          <span className="text-sm text-amber-700">
            Only verified pollsters can vote
          </span>
        </div>
      </div>
    );
  }
  
  // If not logged in
  if (!user) {
    return (
      <div className="px-6 py-2 mb-2">
        <div className="bg-amber-50 p-3 rounded-md flex items-center">
          <Lock size={16} className="text-amber-500 mr-2" />
          <span className="text-sm text-amber-700">
            Sign in as a verified pollster to vote
          </span>
        </div>
      </div>
    );
  }
  
  // If user can vote, don't show any notice
  return null;
};

export default AuthNoticeBar;
